import * as React from "react";
import { iconSize } from "./tools";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCurrentMeeting } from "../contexts/currentMeeting";
import { getConcertoJoinLinkHref, getDownloadSource } from "../../joinMeetingTools";
import { IconButton, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { FormattedMessage } from "react-intl";

export const ListIconContainer = ({ children, style }: { children: React.ReactNode; style?: React.CSSProperties }) => (
    <div
        style={{
            minWidth: iconSize * 1.4,
            fontSize: iconSize,
            display: "flex",
            ...style,
        }}
    >
        {children}
    </div>
);

export const ListIcon = ({ icon }: { icon: IconProp }) => (
    <ListIconContainer>
        <FontAwesomeIcon icon={icon} />
    </ListIconContainer>
);

export const ConcertoClientListItem = () => {
    const currentMeetingData = useCurrentMeeting();
    const invitation = currentMeetingData.selfInvitation;

    const downloadSource = getDownloadSource();
    const imgSize = iconSize * 1.2;
    const margin = (imgSize - iconSize) / 2;

    return (
        <ListItem
            disablePadding
            secondaryAction={
                downloadSource && (
                    <IconButton component="a" href={downloadSource} size="large">
                        <FontAwesomeIcon icon="download" />
                    </IconButton>
                )
            }
        >
            <ListItemButton
                component="a"
                href={getConcertoJoinLinkHref(currentMeetingData.meeting, invitation)}
                sx={{ color: "primary.main", pr: downloadSource ? 9 : 2 }}
            >
                <ListIconContainer style={{ height: imgSize, marginLeft: -margin, marginRight: margin }}>
                    <img src="/static/pics/favicon.png" style={{ width: imgSize }} alt="favicon" />
                </ListIconContainer>
                <ListItemText
                    primary={
                        <FormattedMessage
                            id="meetingPage.clientSelector.nativeClient"
                            defaultMessage="Concerto client"
                        />
                    }
                    secondary={
                        <FormattedMessage
                            id="meetingPage.clientSelector.nativeClientDesc"
                            defaultMessage="Open in external app"
                        />
                    }
                />
            </ListItemButton>
        </ListItem>
    );
};
